import React from 'react'
import type { CtaButtonFragment } from '../../../.graphql/generated-types'
import { LinkToArticlePage } from '../LinkToArticlePage'

export interface CTAButtonProps {
  data: CtaButtonFragment
}

export function CTAButton({ data }: CTAButtonProps) {
  const opensInANewTab = data.opensInANewTab ?? false
  const text = data.text ?? ''
  const target = opensInANewTab ? '_blank' : '_self'
  const rel = opensInANewTab ? 'noreferrer' : ''
  const style =
    'flex-none md:h-14 bg-blog-purply-pink-300 text-center text-white px-10 py-3 rounded font-bold'
  switch (data.link?.__typename) {
    case 'ComposeComponentUrl':
      return (
        <a
          href={data.link.url ?? ''}
          target={target}
          rel={rel}
          className={style}
        >
          {text}
        </a>
      )
    case 'ComposePageArticle':
      return (
        <LinkToArticlePage article={data.link} className={style}>
          {text}
        </LinkToArticlePage>
      )
    default:
      return null
  }
}
